export default __webpack_public_path__ + "static/media/wettbewerber.45014128.png";